import { Alert, Form, Select } from 'antd';
import React, { useState } from 'react';
import { stagesQuery, useSubmit } from '../../../../api';
import BaseModal from '../../../BaseModal/BaseModal';
import { useSetModalVisible } from '../../../../model/modalState';
import InformationBlockModal from '../../../InformationBlockModal/InformationBlockModal';
import { typeMassActionsText } from '../../../InformationBlockModal/constants';

const { Item: FormItem, create: createForm } = Form;
const { Option } = Select;
const { useFetch: useStages } = stagesQuery;

const Container = ({ form, requests, onSuccess }) => {
  const { validateFields, resetFields, getFieldDecorator } = form;

  const [stateInfo, setStateInfo] = useState(false);
  const [value, setValue] = useState(null);

  const setModalVisible = useSetModalVisible();

  const { data = [], isFetching } = useStages({
    staleTime: Infinity,
    notifyOnChangeProps: ['data', 'isFetching'],
    select: (data) => data?.stagesAddressLifeCycle,
  });


  const { submitAsync, loading } = useSubmit({
    url: '/Request/stage',
    errMsg: 'Не удалось изменить стадию помещения у выбранных заявок',
    onSuccess,
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    validateFields((err, values) => {
      if (!err) {
        const value = {
          stageId: values.stageId,
        };

        setValue(value);
        setStateInfo(true);
      }
    });
  };

  const handleConfirmSubmit = async (e) => {
    e.preventDefault();

    try {
      await submitAsync({
        ids: requests.map(({ id }) => id),
        value,
        requests,
      });

      setModalVisible(false);
      setStateInfo(false);
      resetFields();
    } catch (error) {
      return <Alert title={error.message} />;
    }
  };

  const cancelSubmit = () => {
    setStateInfo(false);
    resetFields();
  };

  return (
    <BaseModal
      title={stateInfo ? 'Подтвердите изменения' : 'Изменение стадии помещения'}
      okButtonProps={{ disabled: isFetching }}
      footer={undefined}
      onOk={stateInfo ? handleConfirmSubmit : handleSubmit}
      onCancel={cancelSubmit}
      confirmLoading={loading}
      width={stateInfo ? 600 : 450}
    >
      {!stateInfo ? (
        <Form>
          <FormItem label="Стадия помещения">
            {getFieldDecorator('stageId', {
              rules: [
                {
                  required: true,
                  type: 'number',
                  message: 'Укажите стадию помещения',
                },
              ],
            })(
              <Select placeholder="Выберите стадию помещения">
                {data?.map((stage) => (
                  <Option
                    key={stage.id}
                    value={stage.id}
                  >
                    {stage.name}
                  </Option>
                ))}
              </Select>
            )}
          </FormItem>
        </Form>
      ) : (
        <InformationBlockModal
          typeMassActions={typeMassActionsText.stageReuest}
          count={requests.length}
        />
      )}
    </BaseModal>
  );
};

const ChangeStage = createForm({
  name: 'mass_actions_stage',
})(Container);

export default ChangeStage;
